import { Model as o } from "../../model.js";
class r extends o {
  constructor(t) {
    super(), this.type = t.type, this.operation = t.operation, this.value = t.value, this.unit = t.unit;
  }
}
export {
  r as AudienceModel
};
//# sourceMappingURL=audience.model.js.map
